
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Это стало возможным благодаря
                    <a href="${0}">проекту Folksonomy Engine</a>. Не
                    стесняйтесь участвовать и оставлять отзывы`,
'h5d824b4954e56ea5': html`Сканируйте свою <span class="everyday">ежедневную</span> <span class="foods">пищу</span>`,
'h6bdd1b427aa985a4': html`Этот инструмент позволяет вам исправить список ингредиентов. Вы можете добавлять, удалять или редактировать список ингредиентов
                .
                <br>
                Этот символ <span class="highlight">␣</span> представляет пробел.
                <br>
                Этот символ <span class="highlight">↩︎</span> представляет перенос строки. `,
'hb28f1f2ec1744ee9': html`Эти свойства создаются и сохраняются пользователями для любых целей. Чувствуйте
                    добавлять свои. Создаваемые вами свойства и значения
                    <strong>должно быть достоверными</strong>. Вы можете погрузиться в
                    <a href="${0}">список объектов, уже используемых сообществом</a>
                    или изучите
                    <a href="${1}">'правильную' документацию и ее поисковую систему</a>.`,
's000a5b76bd3a01c2': `Загрузка свойств...`,
's000d98595e959c1e': `Скачайте на Google Play`,
's013bdc8cf0d3583d': `Помогите нам с ингредиентами`,
's01d2865e3e1d5501': `Спасибо за помощь!`,
's02ce7a2e7c1b020b': `Проверить урожай`,
's03e9c8114521b998': `Я отредактирую ингредиенты.`,
's05ec315d9308091a': `Значок углов штрих-кода`,
's061eb5af92512c85': `Сохранено! Можете помочь с еще одним?`,
's06847c221c4c0bc1': `Я хотел бы создать свойство для [опишите вариант использования]...`,
's06f6c6f99db6b552': `Оригинал`,
's081e2ad82db71e1d': `Сгруппированные значения`,
's09205907b5b56cda': `Нет`,
's0b4235aae602a950': `специальная документация`,
's0bb2d48532acc455': `Загрузить CSV-файл`,
's0d5b7fee0311db68': `Свойство`,
's0fb218abc2e157ed': `Сделать изображение недействительным`,
's100c4928cc74642a': `поддерживать развитие исследований в области общественного здравоохранения.`,
's10db5498186c083b': `Отменить обрезку`,
's11a18a69b30b65ed': `Помогите нам исправить ошибки в списке ингредиентов`,
's1205d5f6fccf8e69': `Стоимость недвижимости`,
's15d64a0a6715285a': `Новый ключ`,
's166bd56d19670a72': `Увеличить`,
's19059bf0c4f7c162': `Область выбора`,
's1a52515ec8ddade8': `Штрихкод продукта`,
's1c5031113de500ce': `сохраняя нашу базу данных открытой и доступной для всех,`,
's1dc4daf989c71284': `Помогите нам исправить информацию о пищевой ценности`,
's1e00019dc454872d': `Укажите название свойства, используя атрибут property-name.`,
's1e49126af0935a5b': `Список продуктов, использующих это свойство`,
's21e73088de6f26f3': `Доступно в App Store`,
's255857544a9d5ec0': `Сбросить`,
's25e94495991e95ba': `Спасибо за вашу помощь! Вы можете помочь с другим вопросом?`,
's2ceb11be2290bb1b': `Отмена`,
's2db7b654c0a9bde0': `Документируйте недвижимость`,
's300b3a6ee4e1252d': str`Плохое совпадение ${0}%`,
's33f786bb6b4f0cf4': `Результат обрезки`,
's33f85f24c0f5f008': `Сохранить`,
's34be4af4e8fec4ae': `Сначала спросите сообщество`,
's36d86adc823cbfa6': `Прежде чем создавать новый объект недвижимости, обсудите его с сообществом:`,
's3781d25aa51a736c': `Документация по движку Folksonomy`,
's383ae4449428b61e': `Сбросить обрезку`,
's39bcf88721a1e8ee': `Сбросить выбор`,
's39e14e14300694c7': `Документация и руководства`,
's3b430cfa5c1fe7f4': str`Документация для ${0}`,
's3f4e4b52f230a892': `Изображение холста`,
's417b90913e05bc17': `Предварительный просмотр`,
's41f7dca46d3f1b4a': `Значение`,
's422bba9636ce2489': `Центрировать изображение`,
's42dd66b2441566fd': `Центральная иконка`,
's43df2e8395f6834e': str`Пожалуйста, помогите нашему ${0} Фонду`,
's453188ea728f64da': `Добавить питательное вещество`,
's453ab0dbb9b5c777': `Изменить размер вправо`,
's475b08749d0706ed': `Помогите нам информировать миллионы потребителей по всему миру о том, что они едят`,
's49730f3d5751a433': `Загрузка...`,
's4bbc7472834a9686': `Ваш браузер не поддерживает сканирование штрихкодов.`,
's4d42cc7e00076a3b': `Количество продуктов`,
's4df2f533c0c1e7d0': `Управление изображением`,
's4e94adf723979402': `Open Food Facts нуждается в вашей помощи с этим продуктом.`,
's4f4886341969d552': `Переместить выделение`,
's4f751fb9b3ed766c': `Создание нового свойства`,
's547c12ae169d00bc': `Доступно на F-Droid`,
's5560fb119e40923d': `Введите название объекта...`,
's55d7249883a98ca1': `об этом объекте на Open Food Facts wiki`,
's565867d84c04aea2': `Свойства фильтра...`,
's5666afe5cd0166de': `Пожалуйста, исправьте ошибки или измените текст перед подтверждением.`,
's57472465a23b41db': `Ценности`,
's58e1eeea7a60ae51': `Загрузка товаров...`,
's59df20feee978e5b': `Ошибка: Недопустимое значение.`,
's5c92c0051d44b6de': `Помогите нам исправить информацию о пищевой ценности.`,
's5dd6f12783fca34f': `Изменить список ингредиентов`,
's5e8250fb85d64c23': `Закрыть`,
's5ed03bb1f3a15949': `Изображение`,
's6306a31415aea913': `Я ПОДДЕРЖИВАЮ`,
's6498dfe4855bb3a7': `единица`,
's64ef2a6c2dd1d3d1': `Редактировать`,
's66413c24dcf680e2': `Пропустить`,
's67ae6594857a4d57': `Спасибо за Ваш вклад!`,
's6cee7cad81dfedd1': `Обрезанное изображение`,
's6d7b6cdedaadfb6e': `Каждое пожертвование имеет значение! Мы ценим вашу поддержку в обеспечении большей прозрачности в отношении продовольствия в мире.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Хорошее совпадение ${0}%`,
's71a5c9f4b68ef4d4': `Кол-во`,
's74cb3d66f6a668e1': `Документация`,
's787dd11bed0dc88a': `Изменить размер влево`,
's7ce4fd9430e80cea': `значение`,
's801a05fa8e881f37': `Узнайте больше о создании недвижимости и правилах:`,
's8038273de2cf8b73': `Выберите область для обрезки.`,
's839cc2908a5387f2': `Фильтровать штрихкоды...`,
's86197dcf3e96af64': `Просмотр и поиск существующих объектов недвижимости`,
's8a63be30a129a59c': `Изменить размер нижней части`,
's8a8bfd67f2dd2810': `Загрузите приложение OFF с помощью этого QR-кода`,
's8af61807443f32a4': `Действия`,
's8b33c244759d7bd4': `Изменить размер вверху справа`,
's8db84aa4bc949af2': `Документируйте новую недвижимость`,
's8f839a03997a16d7': `Просмотреть продукт`,
's901ae1e236ac45d3': `Отменить удаление`,
's907f7a97c6b29425': `Имейте в виду, что модель данных может быть изменена. Используйте на свой страх и риск.`,
's95d23d03f9147581': `Свернуть`,
's976dfd19ef58a1e1': `Нажмите, чтобы отсканировать штрихкод и узнать подробности (здоровье, предпочтения и т. д.)`,
's98ff35f2a00dc60d': `Ингредиенты:`,
's9a7f60fce090ecaf': `Не удалось загрузить свойства. Повторите попытку позже.`,
's9b87abd68fb9df45': `Не нашли? Создайте новый ключ {value}`,
's9c0f52425fd2f07e': `Может не совпадать`,
's9fc41f789c63b40d': `Продукты`,
'sa1fa766e0d5634d7': `Оценка недоступна`,
'sa548778b24054030': `Ознакомьтесь со всеми предоставленными ресурсами проекта Folksonomy Engine. Эти ресурсы предоставляют дополнительные метаданные и информацию о продуктах в базе данных Open Food Facts.`,
'sa63907958bd0ec4b': `Изменить размер верхнего левого угла`,
'sa95b4224f685a36a': `Закрыть модальное окно`,
'sab56a1d439576fd6': `Значок предложения`,
'sac47ea2901d04c15': `Изменить размер левого нижнего угла`,
'sb125227d436c2925': `Найдите подходящую для вас концепцию недвижимости в существующей базе данных объектов недвижимости:`,
'sb125568d43642e6f': `Ответьте на вопросы о продукте.`,
'sb1c538e038f9b214': str`Очень хорошее совпадение ${0}%`,
'sb28639570ff3b852': `список всех объектов недвижимости`,
'sb3bdd638a58d30f4': `вовлекать сообщество преданных своему делу граждан,`,
'sb3cbcc1bd0fff140': `Как только вы убедились, что ваша собственность не существует, и сообщество согласится с ее полезностью, вам нужно сначала задокументировать ее в вики.`,
'sb3d4f79d9d8b71e5': `Подтвердить`,
'sb560fa37a7bfb6c2': `Для этого объекта не найдено ни одного товара.`,
'sb7f72e4c8a2d3357': `Значения фильтра...`,
'sb8178320160f84ea': `Показать кадрирование`,
'sbad7d2734149470b': `Подтвердить`,
'sbb623d6b18d966a0': `Пищевая ценность указанная на упаковке:`,
'sbd6be5cde472f37c': `На все вопросы даны ответы! Спасибо за помощь!`,
'sbd9a0b2293b3cd3c': `Размер порции`,
'sbe472dc3c2685985': `Соответствующее значение`,
'sc0520e1732a5c568': `Развернуть изображение`,
'sc0cc559e7ede852a': `Изменить размер верхней части`,
'sc1c08d0cbcc3bd24': `Не соответствует`,
'sc52696641af72b53': `Скачайте приложение!`,
'sc5575e3107f87874': `Повернуть изображение влево`,
'sc57b630a7a70c61f': `Предлагаемое исправление`,
'sc681b137e8f604f7': `Подтвердить удаление`,
'sc6daf8a31883f8b9': `Переместить изображение`,
'sc895972c88d38ca5': `Фолксономическая собственность`,
'sca0c3305aff570b8': str`на указанную порцию "${0}"`,
'scace072bef961918': `Ряды`,
'scb3b0671d7b7f640': `Новое значение`,
'scb489a1a173ac3f0': `Да`,
'scbab4bd737ba7934': str`групповое фото пожертвования ${0}`,
'scd21019c3cd618f3': `Присоединяйтесь к обсуждению в Slack`,
'scdb6cad0b92721bf': `Объекты не найдены.`,
'scf23a05631f93732': `Подтвердить удаление`,
'scfed2f270ef6a3aa': `Выберите область`,
'sd1022bc1ef9204f7': `Масштабируемое изображение`,
'sd1077c055cf9ba6b': `Помогите нам проверить список ингредиентов продукта.`,
'sd698d21ddecba56b': `Эй! Вы можете помочь нам улучшить информацию о продукте, ответив на следующие вопросы:`,
'sd82bc2decefa621b': `оставаться независимыми от пищевой промышленности,`,
'sdb97e5976482606e': `Проверьте, существует ли уже такое свойство`,
'sdbf806fefc584115': `Вам следует найти`,
'sdc673e73b5c13aea': `Удалить`,
'sdc792b75f1edcaba': `Помогите нам исправить написание ингредиентов.`,
'sdca5deead576ceee': `Изменить размер внизу справа`,
'sdcc2555c5dde524f': `Вы уверены, что хотите удалить этот элемент? Это действие не может быть отменено.`,
'se206feec7ec57b28': `на 100 грамм`,
'se419a9ab36987490': `Аннулировать`,
'se5127cf0f92e7e48': `Совет: вы также можете найти`,
'se773f50d2a16d481': `Повернуть изображение вправо`,
'sebb2c6c830a44574': `техническая инфраструктура (сайт/мобильное приложение) и небольшая постоянная команда`,
'sec6377f3c4e9b28c': `Я предложу лучший урожай.`,
'seea3800e27baa686': `Отдельные продукты`,
'sefaba4adc4ec9219': `Фолксономия Свойства`,
'seffa8ca49175b5f0': `Персонализированные свойства`,
'sf44a6b3b232c28ea': str`Заменить текущее значение на ${0}`,
'sf4cd86a2f5ef2588': `Штрихкод продукта`,
'sf57a61152168cc81': `Помогите нам исправить определение ингредиентов`,
'sf88b90b8ba23871c': `Неизвестный матч`,
'sf9aee319a006c9b4': `Добавить`,
'sfacbbe968fa7d773': `Название недвижимости:`,
'sfc40ea3d5d5aa6f8': `Ваши пожертвования финансируют повседневную деятельность нашей некоммерческой ассоциации:`,
'sfe87465d50530725': `Соответствующее значение`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  